module.exports = __webpack_public_path__ + "img/hazardEquip65.e8c18718.jpg";